import type { SocialLink } from '../types';

export const socialLinks: SocialLink[] = [
  {
    label: 'GitHub',
    url: 'https://github.com/Unskilled-Skill',
    icon: 'Github',
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/rochee-faverey-419a612b7/',
    icon: 'Linkedin',
  },
  {
    label: 'ArtStation',
    url: 'https://www.artstation.com/unskilledskill6',
    icon: 'Palette',
  },
  {
    label: 'Email',
    url: 'mailto:rocheefaverey@hotmail.com',
    icon: 'Mail',
  },
];
